import { TransitBannerBase } from "@Base/Site/TransitBannerBase";

import "./TransitBanner.scss";

export class TransitBanner extends TransitBannerBase
{
	constructor()
	{
		super();
	}
}